import { render, staticRenderFns } from "./CompanyContactDashboard.vue?vue&type=template&id=2e9b920d"
import script from "./CompanyContactDashboard.vue?vue&type=script&lang=js"
export * from "./CompanyContactDashboard.vue?vue&type=script&lang=js"
import style0 from "./CompanyContactDashboard.vue?vue&type=style&index=0&id=2e9b920d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports